import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Tennis = () => {
  return (
    <SportsLayoutComp name={'Tennis'}/>
  )
}

export default Tennis